module.exports = __webpack_public_path__ + "media/images/box_sizes/S-a5e352301689fec9ace127c5a4e3ec2d.jpg";